/* eslint-disable react-hooks/exhaustive-deps */
import { FunctionComponent, useEffect, useState } from "react";
import HeaderBasic, {
  HeaderBasicProps,
} from "../../../components/headers/HeaderBasic";
import { TableBase } from "../../../components/Table/TableBase";
import { IDataCollection, IPagination } from "../../../Interfaces/base/ITable";
import {
  CONTIENE_MAYUSCULA,
  CONTIENE_MINUSCULA,
  CONTIENE_NO_ALFANUMERICO,
  CONTIENE_NUMERO,
  _initialFilter,
  _initialPagination,
  baseSearch,
} from "../../../utils/helpers/helpers";
import React from "react";
import {
  DetailsListLayoutMode,
  IColumn,
  ICommandBarItemProps,
  Icon,
  Label,
  PanelType,
  Persona,
  PersonaSize,
  ProgressIndicator,
  Stack,
  TextField,
  TooltipHost,
} from "@fluentui/react";
import IconHelper from "../../../utils/helpers/iconHelper";
import { _initialDataCollection } from "../../../utils/helpers/tableHelper";
import {
  IActualizarContrasenia,
  ISharedUsuario,
  IUsuario,
} from "../../../Interfaces/IUsuario";
import { Ifilter } from "../../../Interfaces/filter";
import configuracionService from "../../../services/configuracionService";
import { useBoolean } from "@fluentui/react-hooks";
import { PanelGenerico } from "../../../components/generic/PanelGenerico";
import { CSSObject } from "styled-components";
import { HeadingBar } from "../../../components/generic/HeadingBar";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ConfigHelper } from "../../../utils/helpers/configHelper";
import usuarioServicio from "../../../services/usuarioService";
import { IPoliticas } from "../../../Interfaces/base/IBase";
import { TagError, TagInfo } from "../../../components/indicadores/Tags";
import { ContainerPersona } from "../../../components/generic/ContainerPersona";
import { PanelCambioContrasenia } from "./CambiarContrasenia/PanelCambioContrasenia";

interface GestionUsuariosProps { }

const GestionUsuarios: FunctionComponent<GestionUsuariosProps> = (prop) => {
  const navigate = useNavigate();

  const [usuario, setUsuario] = useState<IDataCollection<IUsuario>>(
    _initialDataCollection
  );
  const [hidden, setHidden] = useState(false);
  const [column, setColumn] = useState<IColumn[]>([]);
  const [searchParam, setSearchParam] = useSearchParams();

  /* Change Password */
  const [sel, setSel] = useState<ISharedUsuario>(null!);
  const [equal, setEqual] = useState(false);
  const [form, setForm] = useState<IActualizarContrasenia>(null!);

  const [
    isOpenChangePassword,
    { setTrue: openChangePassword, setFalse: dismissChangePassword },
  ] = useBoolean(false);

  /* Filter */
  const [filter, setFilter] = useState<Ifilter>(_initialFilter);

  const [currentPage, setCurrentPage] = React.useState(
    _initialPagination().currentPage
  );
  const [pageSize, setPageSize] = React.useState(_initialPagination().pageSize);
  const [total, setTotal] = React.useState(_initialPagination().total);

  const [pagIngreso, setPagIngreso] = React.useState<IPagination>({
    ..._initialPagination(),
    onPageChange: (page) => setCurrentPage(page),
    onSizeChange: (pageSize) => setPageSize(pageSize),
  });
  const [politicas, setPoliticas] = useState<IPoliticas>(null!);

  const [coincideContraseniaActual, setCoincideContraseniaActual] =
    useState(false);

  const [reqDigito, setReqDigito] = useState(true);
  const [reqMinuscula, setReqMinuscula] = useState(true);
  const [reqNoAlfanumerico, setReqNoAlfanumerico] = useState(true);
  const [reqMayuscula, setReqMayuscula] = useState(true);
  const [cumpleLongitud, setCumpleLongitud] = useState(false);
  const [cumplePoliticas, setCumplePoliticas] = useState(false);

  const [contrasenia, setContrasenia] = useState("");
  const [disableForm, setDisableForm] = useState(true);
  const [confContrasenia, setConfContrasenia] = useState("");
  const [isSend, setIsSend] = useState(false);
  const [textError, settextError] = useState("-");
  const [isContenedor, setIsContenedor] = useState(false);
  const [choice, setChoice] = React.useState<string | undefined>(undefined);
  const resetChoice = React.useCallback(() => setChoice(undefined), []);

  const _leftBar = (): ICommandBarItemProps[] => {
    const _farItemsAsignados: ICommandBarItemProps[] = [
      {
        ...IconHelper.ICON_RELOAD,
        onClick(ev, item) {
          reload();
        },
      },
    ];
    return _farItemsAsignados;
  };
  const _columns = () => {
    let col: IColumn[] = [
      {
        key: "nombre",
        name: "Nombre",
        fieldName: "nombre",
        minWidth: 200,
        maxWidth: 300,
        isResizable: true,
      },
      {
        key: "email",
        name: "Email",
        fieldName: "email",
        minWidth: 200,
        maxWidth: 300,
        isResizable: true,
      },
      {
        key: "sexo",
        name: "Sexo",
        fieldName: "sexo",
        minWidth: 200,
        maxWidth: 300,
        isResizable: true,
        onRender(item,index,colum){
          return(
            <ContainerPersona item={item}/>
          )
        }
      },
      {
        key: "opciones",
        name: "Opciones",
        fieldName: "Opciones",
        minWidth: 200,
        maxWidth: 300,
        isResizable: true,
        onRender(item, index, column) {
          return (
            <>
              <div>
                {/* <Stack horizontal > */}
                <>
                  <TooltipHost content={`Cambiar Contraseña`}>
                    <Icon
                      iconName="AuthenticatorApp"
                      style={iconStyle}
                      onClick={() => {
                        setForm({
                          usuarioId: item.usuarioId,
                          password: "",
                          confirmPassword: "",
                        });

                        setSel({
                          ...sel,
                          usuarioId: item.usuarioId,
                          text: item.nombre,
                          secondaryText: item.email,
                        });
                        openChangePassword();
                      }}
                    />
                  </TooltipHost>

                  <TooltipHost content={`Gestion Usuarios`}>
                    <Icon
                      iconName="BulletedListText"
                      style={iconStyle}
                      onClick={() => {
                        navigate(
                          `${ConfigHelper.urlBase()}/configuraciones/menuUsuarios`,
                          {
                            state: {
                              identityId: item?.identityUserId,
                              usuarioId: item?.usuarioId,
                              nombre: item?.nombre,
                              email: item?.email,
                            },
                          }
                        );
                      }}
                    />
                  </TooltipHost>
                </>
                {/* </Stack> */}
              </div>
            </>
          );
        },
      },
    ];
    setColumn(col);
  };
  /* Api */
  const dataUsuario = (param = filter) => {
    setUsuario(_initialDataCollection);
    configuracionService
      .allUsuario(param)
      .then((res) => {
        if (res.status === 200) {
          setUsuario(res.data);
          setTotal(res.data.total);
        }
      })
      .catch((e: Error) => {
        // alert(splitExceptionDetail(e));
        alert(e);
      })
      .finally(() => {
        setHidden(true);
      });
  };

  /* Function */
  const reload = (param = filter) => {
    setHidden(false);
    _columns();
    dataUsuario(param);
  };

  //CAPTURA DE TAMAÑO DE PAGINA
  const _getPageSize = (value: number) => {
    console.log("Tamaño de pagina : ", value);
    setPageSize(value);
    setFilter({ ...filter, skip: (currentPage - 1) * pageSize, take: value });
    setPagIngreso({ ...pagIngreso, pageSize: value });
  };
  /* Hooks */
  useEffect(() => {
    reload();
  }, []);

  /* Hook Pagination */
  React.useEffect(() => {
    dataUsuario();
  }, [filter.skip, pageSize]);

  React.useEffect(() => {
    setPagIngreso({
      ...pagIngreso,
      currentPage: currentPage,
    });
    /* Solo si no es la primera carga actualiza el paginador */
    if (currentPage >= 1) {
      if (filter) {
        setFilter({
          ...filter,
          skip: (currentPage - 1) * pageSize,
          take: pageSize,
        });
      }
    }
  }, [currentPage]);

  React.useEffect(() => {
    setPagIngreso({
      ...pagIngreso,
      total: total,
    });
  }, [total]);

  const dataApiPoliticas = () => {
    usuarioServicio
      .politicasContrasenia()
      .then((res) => {
        if (res.status == 200) {
          // let arrays: IItemComboBaseDTO[] = res.data;
          // setComboGuardia(arrays);
          setPoliticas(res.data);
        }
      })
      .catch((e) => console.log(e));
  };

  const changePassword = () => {
    if (form) {
      let obj = {
        usuarioId: form.usuarioId,
        confirmPassword: confContrasenia,
        password:""
      };

      setIsSend(true);
      setDisableForm(true);

      configuracionService
        .actualizarContraseniaUsario(obj)
        .then((res) => {
          if (res.status === 200) {
            setIsSend(false);
            //alert("Contraseña cambiada...");
            setContrasenia("");
            setConfContrasenia("");
            setDisableForm(true);

            setChoice("Correcto");
            _cleanValidationInputs();
            // dismissChangePassword();
          }
        })
        .catch((e) => {
          setChoice("Error");
          if (e.response.status === 500) {
            //alert(e.response.data.detail);
            settextError(e.response.data.detail);
          }
          if (e.response.status === 401) {
            // alert(
            //   "No cuenta con autorización, Dirijase a la pagina de inicio de sesion "
            // );
            settextError("No cuenta con autorización");
          }
          //settextError(splitExceptionDetailMensaje(e));
          setContrasenia("");
          setConfContrasenia("");
          setIsSend(false);
          _cleanValidationInputs();
          setTimeout(() => {
            //props.onDismissPanelCrear();
            //cleanInputs();
            setIsContenedor(false);
          }, 3000);
        });
    }
  };

  const _cleanValidationInputs = () => {
    setReqDigito(true);
    setReqMinuscula(true);
    setReqNoAlfanumerico(true);
    setReqMayuscula(true);
    setCumpleLongitud(false);
  };
  /* Event */
  const _onChangeText = (
    type: string,
    event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    newValue?: string
  ) => {
    if (event !== undefined) {
      if (newValue !== undefined) {
        switch (type) {
          case "password":
            setForm({
              ...form,
              password: newValue,
            });
            setContrasenia(newValue);

            break;
          case "confirmPassword":
            setForm({
              ...form,
              confirmPassword: newValue,
            });
            setConfContrasenia(newValue);

            break;
          default:
            break;
        }
      }
    }
  };

  useEffect(() => {
    dataUsuario(filter);
  }, [filter]);

  const _onChangeTextSearch = (
    ev?: React.ChangeEvent<HTMLInputElement>,
    newValue?: string
  ) => {
    if (newValue != undefined) {
      setFilter({ ...filter, search: newValue });
      if (newValue.length == 0) {
        _onClearSearch();
      }
    }
  };

  const _onClearSearch = () => {
    setFilter({
      ...filter,
      search: "",
    });
  };

  const _onPress = (newValue: string) => {
    if (newValue != undefined) {
      setFilter({
        ...filter,
        search: newValue,
      });
    }
  };
  const _getFilter = () => {
    return filter.search ?? "";
  };

  useEffect(() => {
    dataApiPoliticas();
  }, []);

  useEffect(() => {
    validarInputs();
  }, [contrasenia]);

  useEffect(() => {
    validarPoliticas();
  }, [
    reqDigito,
    reqMinuscula,
    reqNoAlfanumerico,
    reqMayuscula,
    cumpleLongitud,
  ]);

  //PANEL
  const validarInputs = () => {
    if (politicas != null) {
      if (confContrasenia.length >= 1) {
        setConfContrasenia("");
      }

      if (contrasenia.length == politicas.longitud) {
        setCumpleLongitud(true);
      } else setCumpleLongitud(false);

      if (politicas.requiereDigito) {
        if (CONTIENE_NUMERO.test(contrasenia)) {
          setReqDigito(true);
        } else setReqDigito(false);
      } else setReqDigito(true);

      if (politicas.requiereMinuscula) {
        if (CONTIENE_MINUSCULA.test(contrasenia)) {
          setReqMinuscula(true);
        } else setReqMinuscula(false);
      } else setReqMinuscula(true);

      if (politicas.requiereMayuscula) {
        if (CONTIENE_MAYUSCULA.test(contrasenia)) {
          setReqMayuscula(true);
        } else setReqMayuscula(false);
      } else setReqMayuscula(true);

      if (politicas.requiereNoAlfanumerico) {
        if (CONTIENE_NO_ALFANUMERICO.test(contrasenia)) {
          setReqNoAlfanumerico(true);
        } else setReqNoAlfanumerico(false);
      } else setReqNoAlfanumerico(true);
    }
  };

  const validarPoliticas = () => {
    if (
      reqDigito &&
      reqMinuscula &&
      reqNoAlfanumerico &&
      reqMayuscula &&
      cumpleLongitud
    ) {
      setCumplePoliticas(true);
    } else setCumplePoliticas(false);
  };

  const validarForm = () => {
    if (
      contrasenia != "" &&
      confContrasenia == contrasenia &&
      cumplePoliticas == true
    ) {
      setDisableForm(false);
    } else setDisableForm(true);
  };
  useEffect(() => {
    validarForm();
  }, [confContrasenia]);

  const _back = () => {
    setContrasenia("");
    setConfContrasenia("");
    setIsSend(false);
    _cleanValidationInputs();
    dismissChangePassword();
  };

  return (
    <>
      {/* <HeaderBasic {...headerProps} /> */}
      <HeadingBar
        title="Usuarios"
        subTitle="Gestión de usuarios"
        searchPlaceholder="Buscar por nombre o email"
        searchChange={_onChangeTextSearch}
        // searchHandler={_onPress}
        searchValue={_getFilter()}
        onClearHandler={_onClearSearch}
      />
      <br />
      <TableBase
        leftBar={_leftBar()}
        isLoading={!hidden}
        pagination={pagIngreso}
        data={usuario.items}
        getPageSize={_getPageSize}
        column={column}
        layout={DetailsListLayoutMode.justified}
      />

    
      {sel != null && sel.usuarioId!="" && 
      <PanelCambioContrasenia usuarioId={sel.usuarioId} sel={sel} isOpen={isOpenChangePassword} onDismiss={dismissChangePassword}/>
      }
    </>
  );
};

export default GestionUsuarios;

const headerProps: HeaderBasicProps = {
  Text: "Usuarios",
  Text2: "Gestión de usuarios",
};

const iconStyle: CSSObject = {
  cursor: "pointer",
  fontSize: "16px",
  padding: 0,
  marginRight: 5,
};
function setChoice(arg0: string) {
  throw new Error("Function not implemented.");
}
